import React, { FC, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { PublicClientProvider } from 'providers';
import { INTERCOM_APP_ID } from 'settings';

import Routes from './Routes';

const useStyles = makeStyles({
  '@global html, body, #root': {
    height: '100%',
  },
});

const Public: FC = () => {
  const hasMountRan = useRef(false);
  useStyles();

  function setupIntercom() {
    window.Intercom?.('boot', {
      app_id: INTERCOM_APP_ID,
    });
  }

  useEffect(() => {
    if (!hasMountRan.current) {
      setupIntercom();
      hasMountRan.current = true;
    }
  });

  return (
    <PublicClientProvider>
      <Routes />
    </PublicClientProvider>
  );
};

export default Public;
